;(function() {
  'use strict'

  angular.module('core.gResponseChart', [])
})()
